import { render, staticRenderFns } from "./cluster.vue?vue&type=template&id=0a89de86&scoped=true"
import script from "./cluster.vue?vue&type=script&lang=js"
export * from "./cluster.vue?vue&type=script&lang=js"
import style0 from "./cluster.vue?vue&type=style&index=0&id=0a89de86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a89de86",
  null
  
)

export default component.exports